import React, { Fragment, PureComponent } from 'react';
import Switch from "react-bootstrap-switch";
import ReactDatetime from "react-datetime";
import moment from 'moment';
// reactstrap components
import { Row, Button, Input } from "reactstrap";
// Request
import { uploadClientDocument, saveClientDocumentUrl, updateClientRequest } from 'api/client';
import { deleteImagesArrayRequest } from 'api/image';
// Component
import InputFile from "./InputFile";

export default class SaleStage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            uploading: {},
            isDisabled: false,
            others: []
        }
    }

    componentDidMount() {
        this.setState({
            others: this.props.others || []
        })
        this.checkIfFieldsAreFilled();
    }

    checkIfFieldsAreFilled = () => {
        const { fields=[] } = this.props;
        const state = {
            fieldValues: {}
        };
        let allFieldsFilled = true;
        fields.map(field => {
            if( field.key !== "isCompleted" &&
                field.key !== "completionDate" &&
                field.key !== "others" &&
                (field.value === null || field.value === "")
            ) {
                allFieldsFilled = false
            }
            state['fieldValues'][field.key] = field.value
            return true;
        });
        state['allFieldsFilled'] = allFieldsFilled;
        this.setState({ ...state });
    }

    onFileUpload = (key) => async (file) => {
        try {
            this.setState((prevState) => ({
                uploading: {
                    ...prevState.uploading,
                    [key]: true
                }
            }));
            const { client, stage } = this.props;
            const documentUrl = await uploadClientDocument(client._id, file);
            await saveClientDocumentUrl(client._id, { stage, documentName: key, documentUrl });
            this.updateClientObject(key, documentUrl);
            this.setState((prevState) => ({
                uploading: {
                    ...prevState.uploading,
                    [key]: false
                },
                fieldValues: {
                    ...prevState.fieldValues,
                    [key]: documentUrl
                }
            }));
        } catch(err) {

        }
    }

    onFileDelete = (key) => async (image) => {
        const { client, stage } = this.props;
        await deleteImagesArrayRequest({
            images: [image]
        });
        await saveClientDocumentUrl(client._id, { stage, documentName: key, documentUrl: null });
        this.updateClientObject(key, null);
        this.setState((prevState) => ({
            fieldValues: {
                ...prevState.fieldValues,
                [key]: null
            }
        }));
    }

    onChangeDate = async (date, key) => {
        try {
            const { client, stage } = this.props;
            await saveClientDocumentUrl(client._id, { stage, documentName: key, documentUrl: date });
            this.updateClientObject(key, date);
        } catch(err) {

        }
    }

    handleToggleChange = async (key, state) => {
        try {
            const { client, stage } = this.props;
            this.setState((prevState) => ({
                fieldValues: {
                    ...prevState.fieldValues,
                    [key]: state
                }
            }));
            await saveClientDocumentUrl(client._id, { stage, documentName: key, documentUrl: state });
            this.updateClientObject(key, state);
        } catch(err) {

        }
    }

    updateClientObject = (key, value) => {
        const { client, stage, updateClient } = this.props;
        let updatedClient = { ...client };
        updatedClient = {
            ...updatedClient,
            stages_of_sale: {
                ...updatedClient.stages_of_sale,
                [stage]: {
                    ...updatedClient.stages_of_sale[stage],
                    [key]: value
                }
            }
        }
        updateClient(updatedClient);
        this.checkIfFieldsAreFilled();
        return updatedClient;
    }

    markAsCompleted = async () => {
        try {
            const { client, stage, updateClient } = this.props;

            let updatedClient = { ...client };
            if(updatedClient.stages_of_sale[stage].isCompleted) {
                // Marked as not completed
                updatedClient = {
                    ...updatedClient,
                    stages_of_sale: {
                        ...updatedClient.stages_of_sale,
                        [stage]: {
                            ...updatedClient.stages_of_sale[stage],
                            isCompleted: false,
                            completionDate: null
                        }
                    }
                }

            } else {
                // Marked as completed
                updatedClient = {
                    ...updatedClient,
                    stages_of_sale: {
                        ...updatedClient.stages_of_sale,
                        [stage]: {
                            ...updatedClient.stages_of_sale[stage],
                            isCompleted: true,
                            completionDate: moment().toDate()
                        }
                    }
                }
            }
            updateClient(updatedClient);
            updateClientRequest(updatedClient)
            return updatedClient;

        } catch(err) {
            console.log(err)
        }
    }
 
    renderStageField = (field) => {
        const { fieldValues={}, uploading={}, isDisabled } = this.state;
        const value = fieldValues[field.key]
        switch(field.type) {
            case 'date': 
                return <div className="input-content">
                    <h5>{field.label}</h5>
                    <ReactDatetime
                        inputProps={{
                            className: "form-control",
                            placeholder: "Select Date",
                        }}
                        className={isDisabled ? 'data-disabled' : null}
                        timeFormat={false}
                        value={typeof value === 'string' ? moment(value).format("MM/DD/YYYY") : value}
                        onChange={(date) => this.onChangeDate(date, field.key)}
                        closeOnSelect={true}
                    />
                </div>
            case 'file':
                return <InputFile disabled={isDisabled} uploading={uploading[field.key]} title={field.label} onUpload={this.onFileUpload(field.key)} onDelete={this.onFileDelete(field.key)} value={value} />
            case 'toggle':
                return <div className="input-content">
                            <h5>{field.label}</h5>
                            <Switch value={!!value} onText="" disabled={isDisabled} name="field.key" offText="" onChange={(el, state) => this.handleToggleChange(field.key, state)} />
                        </div>
            case 'text':
                return <div className="input-content">
                            <h5>{field.label}</h5>
                            <Input style={{width: 300}} value={value} disabled={isDisabled} name="field.key" offText="" onChange={(e) => this.setState({"field.key": e.target.value})} />
                        </div>
            default: return <p>Default case in renderStageField</p>
        }
    }

    addOtherField = () => {
        const otherFields = [...this.state.others];
        otherFields.push('');
        this.setState({
            others: otherFields
        });
    }

    onOtherFileUpload = (index) => async (file) => {
        try {
            this.setState((prevState) => ({
                uploading: {
                    ...prevState.uploading,
                    [index]: true
                }
            }));
            const { client, stage } = this.props;
            const { others=[] } = this.state;
            const documentUrl = await uploadClientDocument(client._id, file);
            others[index] = documentUrl;
            await saveClientDocumentUrl(client._id, { stage, documentName: 'others', documentUrl: others });
            this.updateClientObject('others', others);
            this.setState((prevState) => ({
                uploading: {
                    ...prevState.uploading,
                    [index]: false
                },
                others
            }));
        } catch(err) {

        }
    }

    onOtherFileDelete = (index) => async (image) => {
        const { client, stage } = this.props;
        const { others } = this.state;
        await deleteImagesArrayRequest({
            images: [image]
        });
        others.splice(index, 1);
        await saveClientDocumentUrl(client._id, { stage, documentName: 'others', documentUrl: others });
        this.updateClientObject('others', others);
        this.setState({
            others
        });
    }

    render() {

        const { 
            fields=[], 
            isCompleted=false, 
            completionDate=null,
            title=''
        } = this.props;

        const {
            allFieldsFilled=false,
            others = [],
            uploading
        } = this.state;

        return (
            <div className='step'>
                <h2 className="mt-3">{title}</h2>
                {isCompleted &&
                    <div className="is-completed">
                        <div className="input-content">
                            <h5>Step completed</h5>
                            <ReactDatetime
                                inputProps={{
                                    className: "form-control",
                                    placeholder: "Select Date",
                                }}
                                timeFormat={false}
                                value={moment(completionDate).format("MM/DD/YYYY")}
                                disabled
                            />
                            <Switch value={isCompleted} onText="" name="isCompleted" offText="" onChange={(el, state) => this.markAsCompleted()} />
                        </div>
                    </div>
                }
                {!isCompleted && allFieldsFilled &&
                    <div className='is-completed'>
                        <div className="input-content">
                            <h5>All fields are filled. Mark this step as completed?</h5>
                            <Switch value={isCompleted} onText="" name="isCompleted" offText="" onChange={(el, state) => this.markAsCompleted()} />
                        </div>
                    </div>
                }
                {
                    fields.map(field => {
                        return (<Fragment key={field.key}>
                            {this.renderStageField(field, isCompleted)}
                        </Fragment>);
                    })
                }
                <div className='input-content'>
                    <h5>
                        Other documents 
                        <span className='ml-3'>
                            <i className="fa fa-plus cursor-pointer" title="Add other documents" onClick={this.addOtherField} />
                        </span>
                    </h5>
                </div>
                    {
                        others && others.map((otherField, index) => {
                            return <InputFile onUpload={this.onOtherFileUpload(index)} onDelete={this.onOtherFileDelete(index)} uploading={uploading[index]} key={index} title="" value={otherField} />
                        })
                    }
                <Row className="d-flex justify-content-lg-around">
                    <Button 
                        onClick={this.props.previousStep}
                        disabled={!this.props.previousStep}
                    >
                        Previous Step
                    </Button>
                    <Button 
                        onClick={this.props.nextStep}
                        disabled={!this.props.nextStep}
                    >
                        Next Step
                    </Button>
                </Row>
            </div>
        )
    }
}